import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import io from "socket.io-client";
import { signInSocket } from "../../config/TokenHelper";
import {
  changeLayout,
  changeTopbarTheme,
  changeLayoutWidth,
  toggleRightSidebar as toggleRightSidebarAction,
} from "../../store/actions";

// Other Layout related Component
import Navbar from "./Navbar";
import Header from "./Header";
import Footer from "./Footer";
import Rightbar from "../CommonForBoth/Rightbar";

const Layout = (props) => {
  const [isMenuOpened, setIsMenuOpened] = useState(false);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    // Scroll to the top of the page
    window.scrollTo(0, 0);

    const SERVER = "https://socket.hotelslubumbashi.com:5001";
    const newSocket = io.connect(SERVER, { secure: true });

    signInSocket(newSocket);

    newSocket.on("connected", () => {
      setSocket(newSocket);
      console.log("Socket Connected");
    });

    newSocket.on("new-notification-received", (data) => {
      // Handle new notifications
      console.log("New notification received:", data);
    });

    // Cleanup when component unmounts
    return () => {
      if (newSocket) {
        newSocket.disconnect();
      }
    };
  }, []);

  useEffect(() => {
    if (props.isPreloader === true) {
      // Emit update via socket if connected
      if (socket) {
        socket.emit("update", props);
      }

      const preloader = document.getElementById("preloader");
      const status = document.getElementById("status");

      if (preloader && status) {
        preloader.style.display = "block";
        status.style.display = "block";

        setTimeout(function () {
          preloader.style.display = "none";
          status.style.display = "none";
        }, 2500);
      }
    } else {
      const preloader = document.getElementById("preloader");
      const status = document.getElementById("status");

      if (preloader && status) {
        preloader.style.display = "none";
        status.style.display = "none";
      }
    }
  }, [props.isPreloader, socket, props]);

  /**
   * Open/close right sidebar
   */
  const handleToggleRightSidebar = () => {
    props.toggleRightSidebarAction();
  };

  /**
   * Opens the menu - mobile
   */
  const openMenu = () => {
    setIsMenuOpened(!isMenuOpened);
  };

  return (
    <React.Fragment>
      <div id="preloader">
        <div id="status">
          <div className="spinner">
            <i className="ri-loader-line spin-icon"></i>
          </div>
        </div>
      </div>

      <div id="layout-wrapper">
        <Header
          theme={props.topbarTheme}
          isMenuOpened={isMenuOpened}
          toggleRightSidebar={handleToggleRightSidebar}
          openLeftMenuCallBack={openMenu}
        />
        <Navbar menuOpen={isMenuOpened} />
        <div className="main-content">
          {props.children}
          <Footer />
        </div>
      </div>
      <Rightbar />
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  return {
    ...state.Layout,
  };
};

export default connect(mapStatetoProps, {
  changeTopbarTheme,
  toggleRightSidebarAction,
  changeLayout,
  changeLayoutWidth,
})(withRouter(Layout));
